import axios from 'axios';
// import { enqueueSnackbar } from 'notistack';
import { toast } from 'sonner';

interface ErrorResponse {
  message: string;
  code?: string;
}

// 성공 실패 메시지 정리 유틸
export const API_MESSAGE = {
  // CommonResponseCode
  INTERNAL_SERVER_ERROR: 'Internal server error',
  NOT_FOUND: 'Resource not found',
  UNAUTHORIZED: 'Unauthorized',
  FORBIDDEN: 'Forbidden resource',
  BAD_REQUEST: 'Bad request',
  CREATE_SUCCESS: 'Creation successful',
  UPDATE_SUCCESS: 'Update successful',
  DELETE_SUCCESS: 'Deletion successful',
  CREATE_FAIL: 'Creation failed',
  UPDATE_FAIL: 'Update failed',
  DELETE_FAIL: 'Deletion failed',
  FILE_UPLOAD_FAIL: 'File upload failed',
  INVALID_REQUEST: 'Invalid request',

  // AdminAuthResponseCode
  ADMIN_LOGIN_SUCCESS: '관리자 로그인 성공',
  ADMIN_INVALID_CREDENTIALS: '관리자 로그인 실패',

  // MemberAuthResponseCode
  DUPLICATE_ID: '아이디 중복',
  DUPLICATE_EMAIL: '이메일 중복',
  DUPLICATE_CHECK_SUCCESS: '사용 가능한 아이디 또는 이메일',
  CREATE_ID_FAIL: '계정 생성 실패',
  CREATE_DEVICE_FAIL: '디바이스 정보 생성 실패',
  SIGN_IN_SUCCESS: '로그인 성공',
  SIGN_IN_FAIL: '로그인 실패',
  SIGN_UP_SUCCESS: '회원가입 성공',
  FIND_ID_SUCCESS: '아이디 찾기 성공',
  FIND_PASSWORD_SUCCESS: '비밀번호 찾기 성공',
  INVALID_MEMBER_AUTH_CODE: '유효하지 않은 인증 코드입니다. 다시 시도해주세요.',
  CHANGE_PASSWORD_SUCCESS: '비밀번호 변경 성공',
  CHANGE_DEVICE_SUCCESS: '디바이스 정보 변경 성공',
  SIGN_IN_DEVICE_FAIL: '로그인 디바이스 정보가 일치하지 않습니다.',
  CREATE_MEMBER_AUTH_CODE_FAIL: '인증 코드 생성 실패',
  TOKEN_CREATE_FAIL: '토큰 생성 실패',
  NOT_FOUND_SNS_ID: 'SNS 아이디가 존재하지 않습니다.',
  NOT_ALLOWED_PROVIDER: '허용되지 않은 프로바이더',
  NOT_ALLOWED_EMAIL: '허용되지 않은 이메일',
  NOT_ALLOWED_NAME: '허용되지 않은 이름',
  DELETE_DEVICE_FAIL: '디바이스 삭제 실패',

  // AdminMemberResponseCode
  CODE_NOT_AVAILABLE: '코드가 사용 불가능합니다.',
  CODE_USE_FAIL: '코드 사용 실패',
  CODE_REFUND_FAIL: '코드 환불 실패',

  // AdminCodeResponseCode
  CODE_CREATE_SUCCESS: '코드 생성 성공',
  CODE_UPDATE_SUCCESS: '코드 수정 성공',
  CODE_FIND_ALL_SUCCESS: '코드 조회 성공',
  CODE_CREATE_FAIL: '코드 생성 실패',
  CODE_UPDATE_FAIL: '코드 수정 실패',
  CODE_DUPLICATE_CHECK_SUCCESS: '코드 중복 확인 성공',
  FIND_CODE_COUNT_SUCCESS: '코드 개수 조회 성공',

  // AdminPaymentResponseCode
  PAYMENT_FIND_ALL_SUCCESS: '결제 목록 조회 성공',
  FIND_PAYMENT_COUNT_SUCCESS: '결제 개수 조회 성공',

  // ExamResponseCode
  EXAM_MASTER_FIND_ALL_SUCCESS: '문제 마스터 목록 조회 성공',
  EXAM_MASTER_CREATE_SUCCESS: '문제 마스터 생성 성공',
  EXAM_MASTER_UPDATE_SUCCESS: '문제 마스터 수정 성공',
  EXAM_FIND_ALL_SUCCESS: '문제 목록 조회 성공',
  EXAM_SAMPLE_FIND_ALL_SUCCESS: '문제 샘플 목록 조회 성공',
  EXAM_SAMPLE_CREATE_SUCCESS: '문제 샘플 생성 성공',
  EXAM_SAMPLE_DELETE_SUCCESS: '문제 샘플 삭제 성공',
  EXAM_DETAIL_FIND_SUCCESS: '문제 상세 조회 성공',
  EXAM_CREATE_SUCCESS: '문제 생성 성공',
  EXAM_UPDATE_SUCCESS: '문제 수정 성공',
  EXAM_MASTER_UPDATE_FAIL: '문제 마스터 수정 실패',
  EXAM_SAMPLE_DELETE_FAIL: '문제 샘플 삭제 실패',
  EXAM_UPDATE_FAIL: '문제 수정 실패',
  EXAM_IMAGE_UPLOAD_SUCCESS: '문제 이미지 업로드 성공',

  // AdminTermsResponseCode
  ADMIN_TERMS_UPDATE_SUCCESS: '약관 수정 성공',
  ADMIN_TERMS_UPDATE_FAIL: '약관 수정 실패',

  // AdminProfileResponseCode
  ADMIN_PASSWORD_CHANGE_SUCCESS: '관리자 비밀번호 변경 성공',
  ADMIN_PASSWORD_CHANGE_FAIL: '관리자 비밀번호 변경 실패',

  // MemberProfileResponseCode
  MEMBER_PROFILE_DETAIL_SUCCESS: '회원 프로필 조회 성공',
  MEMBER_PROFILE_MEMBER_NOT_FOUND: '회원이 존재하지 않습니다.',
  MEMBER_PROFILE_EMAIL_ALREADY_EXIST: '이미 사용 중인 이메일입니다.',
  MEMBER_PROFILE_CHANGE_EMAIL_FAIL: '이메일 변경 실패',
  MEMBER_PROFILE_CHANGE_EMAIL_SUCCESS: '이메일 변경 성공',
  MEMBER_PROFILE_CHANGE_PASSWORD_FAIL: '비밀번호 변경 실패',
  MEMBER_PROFILE_CHANGE_PASSWORD_SUCCESS: '비밀번호 변경 성공',
  MEMBER_PROFILE_DELETE_DEVICE_FAIL: '디바이스 삭제 실패',
  MEMBER_PROFILE_DELETE_DEVICE_SUCCESS: '디바이스 삭제 성공',
  MEMBER_PROFILE_RESET_EXAM_FAIL: '문제풀이 초기화 실패',
  MEMBER_PROFILE_RESET_EXAM_SUCCESS: '문제풀이 초기화 성공',
  MEMBER_PROFILE_WITHDRAW_FAIL: '회원 탈퇴 실패',
  MEMBER_PROFILE_DEVICE_TOKEN_RESET_FAIL: '디바이스 토큰 초기화 실패',
  MEMBER_PROFILE_WITHDRAW_SUCCESS: '회원 탈퇴 성공',

  // PaymentResponseCode
  PAYMENT_VERIFICATION_FAILED: '결제 영수증 검증에 실패했습니다. 유효하지 않은 구매입니다.',
  PAYMENT_REFUND_FAILED: '결제 환불 요청에 실패했습니다. 잠시 후 다시 시도하거나 고객센터에 문의하십시오.',
  PRODUCT_NOT_FOUND: '구매하려는 상품을 찾을 수 없습니다.',
  PAYMENT_SUCCESS: '결제 성공',
  PAYMENT_WEBHOOK_SUCCESS: '결제 웹훅 처리 성공',

  // MemberCodeResponseCode
  MEMBER_CODE_USE_SUCCESS: '회원 코드 사용 성공',
  MEMBER_CODE_USE_FAIL: '회원 코드 사용 실패',
  MEMBER_CODE_NOT_FOUND: '회원 코드를 찾을 수 없습니다.',
  MEMBER_CODE_ALREADY_USED: '회원 코드가 이미 사용되었습니다.',
  MEMBER_CODE_NOT_AVAILABLE: '유효하지 않은 회원 코드입니다.',
  MEMBER_PERMISSION_UPDATE_FAIL: '회원 권한 업데이트 실패',

  // MemberExamResponseCode
  EXAM_MASTER_START_SUCCESS: '문제풀이 시작 성공',
  EXAM_MASTER_END_SUCCESS: '문제풀이 종료 성공',
  EXAM_MASTER_END_FAIL: '문제풀이 종료 실패',
  EXAM_MASTER_FIND_ALL_MEMBER_CODE1_NOT_FOUND: '문제마스터 조회 실패 - 1급 코드 미보유',
  EXAM_MASTER_FIND_ALL_MEMBER_CODE2_NOT_FOUND: '문제마스터 조회 실패 - 2급 코드 미보유',
  EXAM_MASTER_START_ALREADY_STARTED: '문제풀이 시작 실패 - 이미 시작됨',
  EXAM_MASTER_START_FAIL: '문제풀이 시작 실패',
  EXAM_MASTER_END_NOT_FOUND: '문제풀이 종료 실패 - 문제풀이 마스터 없음',
  EXAM_UPDATE_NOT_FOUND: '문제 수정 실패 - 문제 없음',
  EXAM_SAMPLE_UPDATE_SUCCESS: '샘플문제 수정 성공',
  EXAM_SAMPLE_UPDATE_FAIL: '샘플문제 수정 실패',
  EXAM_SAMPLE_UPDATE_NOT_FOUND: '샘플문제 수정 실패 - 샘플문제 없음'
};

// 싫패에 대한 처리를 해주는 함수
export const handleError = (error: any, defaultMessage = '네트워크 오류가 발생했습니다.') => {
  if (axios.isAxiosError(error)) {
    const errorData = error.response?.data as ErrorResponse;

    const customMessage = API_MESSAGE[errorData?.code as keyof typeof API_MESSAGE] || defaultMessage;
    toast.error(customMessage);

    return;
  }

  toast.error('알 수 없는 오류가 발생했습니다');
};

// 성공에 대한 처리를 해주는 함수
export const handleSuccess = (message: string) => {
  toast.success(message);
};

// 수동 오류처리를 해주는 함수
export const handleCustomError = (message: string) => {
  toast.error(message);
};
